<template>
  <section v-if="locations?.length" class="accommodations defaultSectionMargins" :class="{ 'accommodations--Brand': isBrand }">
    <div class="container">
      <h2 v-text="data.title" />

      <p v-if="data.description" class="accommodations__Description">{{ data.description }}</p>
  
      <div class="accommodations__List">
        <SimilarAccommodationsSlider :locations="locations" :flickityOptions="flickityOptions" />
      </div>
    </div>
  </section>
</template>

<script setup>
  const props = defineProps({
    data: {}
  });
  const { page } = usePage();
  const { accommodationsData } = useSetup();
  const dataLayerList = useState('dataLayerList');

  const flickityOptions = {
    pageDots: false,
    contain: true,
    cellAlign: 'left',
  };

  const isBrand = computed(() => page.value.meta.type.includes('BrandDetail'));
  const locations = computed(() => {
    if (page.value?.accommodations?.length) {
      let accommodationsList = [];
      for (const item of page.value.accommodations) {
        if (accommodationsData.value[item]) accommodationsList.push(accommodationsData.value[item]);
      }
      return accommodationsList;
    } else {
      return Object.values(accommodationsData.value).filter(item => {
        if (isBrand.value) return item.brand_id === page.value.id;
        return item.place.name === page.value.name
      })
    }
  });
  
  let allItems = JSON.parse(JSON.stringify(locations.value));
  let ecommerceItems = [];
  ecommerceItems = allItems.map((accommodation, index) => {
    return {
      'item_id': accommodation.id,
      'item_name': accommodation.name,
      'item_category': accommodation.kind === 'CAMP' ? 'Campsites' : 'Hotels and resorts',
      'item_category2': accommodation.place?.name,
      'item_brand': accommodation.brand?.name,
      'item_list_name': props.data.title,
      'item_list_id': page.value?.seo_page_type,
      'index': index + 1,
    }
  });

  onMounted(() => {
    dataLayerList.value = ecommerceItems;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      'event': 'view_item_list',
      'ecommerce': {
        'items': ecommerceItems,
      },
    });
  });
</script>

<style lang="scss">
  @import url('@/assets/styles/components/blocks/_accommodations.scss');
</style>